import { Service } from '@common/types';
import { Box } from '@wix/design-system';
import { FC } from 'react';
import ServicesList from './ServicesList';

type ServicesWithoutCategoriesProps = {
  services: Service[];
};

const ServicesWithoutCategories: FC<ServicesWithoutCategoriesProps> = ({
  services,
}) => {
  return (
    <Box
      direction="vertical"
      dataHook="services-without-categories"
      width="50%"
    >
      <ServicesList services={services} />
    </Box>
  );
};

export default ServicesWithoutCategories;
